import { render, staticRenderFns } from "./PageTitleComponent.vue?vue&type=template&id=742ba190&"
import script from "./PageTitleComponent.vue?vue&type=script&lang=js&"
export * from "./PageTitleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports